import { ArdoqId, APIWorkspaceAttributes } from '@ardoq/api-types';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { Link } from '@ardoq/link';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { formatDateShort } from '@ardoq/date-time';
import { Locale } from '@ardoq/locale';
import { type I18nLocale, t } from '@ardoq/i18n';
import type { GetWorkspaceManagerLinkProps } from './types';

export type WorkspacesDatasourceInformationFooterProps = {
  workspace: APIWorkspaceAttributes;
  canManageWorkspace: (workspaceId: ArdoqId) => boolean;
  getWorkspaceManagerLinkProps: GetWorkspaceManagerLinkProps;
  locale: Locale;
  i18nLocale: I18nLocale;
};

export const WorkspacesDatasourceInformationFooter = ({
  workspace,
  canManageWorkspace,
  getWorkspaceManagerLinkProps,
  locale,
  i18nLocale,
}: WorkspacesDatasourceInformationFooterProps) => (
  <FlexBox gap="medium" align="center">
    <FlexBox gap="xsmall" align="center">
      <Icon
        iconName={IconName.UPDATE}
        iconSize={IconSize.SMALL}
        color={colors.icon}
      />
      <Text variant="text2" color="textSubtle">
        {t(
          i18nLocale,
          'inventory:datasourceInformation.lastUpdated',
          'Last updated:'
        )}{' '}
        {formatDateShort(workspace.lastUpdated, locale)}
      </Text>
    </FlexBox>
    {canManageWorkspace(workspace._id) && (
      <>
        <Link
          hideIcon
          typography="text2"
          {...getWorkspaceManagerLinkProps(workspace._id, 'component-types')}
        >
          {t(
            i18nLocale,
            'inventory:datasourceInformation.workspaceManager',
            'Workspace manager'
          )}
        </Link>
        <Link
          hideIcon
          typography="text2"
          {...getWorkspaceManagerLinkProps(workspace._id, 'fields')}
        >
          {t(
            i18nLocale,
            'inventory:datasourceInformation.editFields',
            'Edit fields'
          )}
        </Link>
      </>
    )}
  </FlexBox>
);
